import React from "react"
import { Controller, FieldValues, Control, FieldPath, RegisterOptions } from "react-hook-form"
import { TextField, TextFieldProps } from "@mui/material"
import { GetTextFieldStyle } from "lib/styles/textField"

type formTextFieldProps<T extends FieldValues> = {
    control: Control<T>
    name: FieldPath<T>
    label?: string
    rules?: RegisterOptions<T>
    renderError?: (error: string) => React.ReactNode
} & Omit<TextFieldProps, "name" | "label" | "error" | "helperText">

export function FormTextField<T extends FieldValues>({
    control,
    name,
    label,
    rules,
    renderError,
    ...rest
}: formTextFieldProps<T>) {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field, fieldState }) => {
                const error = fieldState.error?.message

                return (
                    <TextField
                        {...field}

                        fullWidth
                        error={!!error}
                        helperText={error && renderError ? renderError(error) : error}
                        {...rest}
                        sx={GetTextFieldStyle()}
                    />
                )
            }}
        />
    )
}
